import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { PerPersonnelModel } from '../../personnel-operations/model/per-personnel-model';
import { PerPersonnelService } from '../../personnel-operations/service/per-personnel-service';
import { UiTranslateLoaderService } from 'ui-shared';
import { HrAuthority, PerEmployeeCardsService, SelectedPersonnelService } from 'humanresources-common-shared';
import { ActivatedRoute } from '@angular/router';
import { JsonConvert } from 'json2typescript';
import { HvlSecurityService } from '@hvlng/framework-bff/security';
import { PerPersonnelQueryModel } from '../../personnel-operations/model/per-personnel-query-model';
import { PerPersonnelSearchQueryModel } from '../../personnel-operations/model/hr-per-personnel-search-query-model';
import { PerPeopleService } from '../../personnel-operations/service/per-people-service';
import { Subject } from 'rxjs';
import { PersonnelPickerComponent } from '../../personnel-picker/component/personnel-picker.component';

@Component({
    selector: 'hr-per-list-viewer',
    templateUrl: './personnel-list-viewer.component.html',
    styleUrls: ['./personnel-list-viewer-page.component.scss'],
})
export class PersonnelListViewerPageComponent implements OnInit {
    @Output() onRowSelect: EventEmitter<PerPersonnelModel> = new EventEmitter();
    @Output() onRowDelete: EventEmitter<PerPersonnelModel> = new EventEmitter();
    @Output() onListClear: EventEmitter<any> = new EventEmitter();

    @Input() pageCode: string;
    @Input() showPerPicture: boolean = true;
    @Input() scrollHeight: string = '37rem';
    @Input() headerTitle: string;
    @Input() remember: boolean = false;
    @Input() employeeTypeUuidList: string[];
    @Input() showStatsToTop: boolean = false;

    @ViewChild('perPickerId') personnelPicker: PersonnelPickerComponent;
    modelList: Array<PerPersonnelModel> = [];
    selectedItem: PerPersonnelModel;
    selectedPersonnelPickerData: any = [];
    @Output() onRemember = new EventEmitter<any>();
    isHrAdmin = false;
    fromTree = false;
    personnelQuery = new PerPersonnelQueryModel();
    isManager = false;
    searchQueryModel = new PerPersonnelSearchQueryModel();
    fromSave: boolean = false;
    selectedItemIdObservable = new Subject();
    pickerSearchResult = null;
    username = "";

    constructor(
        private translateLoaderService: UiTranslateLoaderService,
        private perPersonnelService: PerPersonnelService,
        private selectedPersonnelService: SelectedPersonnelService,
        private activatedRoute: ActivatedRoute,
        private hvlSecurityService: HvlSecurityService,
        private perPeopleService: PerPeopleService,
        private employeeCardService: PerEmployeeCardsService,
    ) {
    }

    checkRouteParams() {
        this.activatedRoute.queryParamMap.subscribe((params) => {
            if (params.has('from') && params.get('from') == 'tree' && params.has('personnelId')) {
                this.fromTree = true;
                this.perPersonnelService.getByPersonnelId(parseInt(params.get('personnelId'))).subscribe((data) => {
                    this.setPerData([data], true);
                });
            } else if (params.has('from') && params.has('personnelId') && params.get('from') == 'save') {
                this.perPersonnelService.getByPersonnelId(parseInt(params.get('personnelId'))).subscribe((data) => {
                    this.fromSave = true;
                    this.setPerData([data], false);
                    this.selectIfExist(data.id);
                });
            } else if (params.has('from') && params.has('personnelId') && params.get('from') == 'mail') {
                this.perPersonnelService.getByPersonnelId(parseInt(params.get('personnelId'))).subscribe((data) => {
                    this.setPerData([data], true);
                    this.selectIfExist(data.id);
                });
            }
        });
    }

    async ngOnInit() {
        this.personnelQuery.active = null;

        this.employeeCardService.getEmployeeCardAuthorityRoleCodes().subscribe((data) => {
            this.personnelQuery.authorizationRoleTypeCodeList = data;
            this.searchQueryModel.authorizationRoleTypeCodeList = data;
        });

        this.searchQueryModel.showPassivePersonnels = true;
        this.searchQueryModel.employeeTypeUuidList = this.employeeTypeUuidList;

        this.modelList = [];
        await this.setPersonnelListByRole();
    }

    async setPersonnelListByRole() {
        this.personnelQuery.onlySubEmployee = false;
        this.searchQueryModel.onlySubEmployee = false;

        if (this.hvlSecurityService.isSecurityActive) {
            this.isHrAdmin =
                this.hvlSecurityService.hasAuthority(HrAuthority.Personnel.Admin.BASE) ||
                this.hvlSecurityService.hasAuthority(HrAuthority.Payroll.PersonnelMasterData.ALL.BASE);
            this.username = this.hvlSecurityService.user.username;
        }

        this.isManager = await this.isManagerByLoggedInPersonnel();
        if (this.isManager) {
            if (!this.isHrAdmin) {
                this.personnelQuery.onlySubEmployee = true;
                this.searchQueryModel.onlySubEmployee = true;
            }
            await this.getPersonnelList();
        }
        if (this.remember === true && this.fromTree === false) {
            let storage = this.getStorage();
            if (storage && storage.length > 0) {
                this.modelList = storage;
                this.selectedPersonnelPickerData = this.modelList;
                this.onRemember.emit(this.getStorage());
            }
        }

        this.checkRouteParams();
    }

    async isManagerByLoggedInPersonnel(): Promise<any> {
        return new Promise((resolve) => {
            this.perPersonnelService.isManagerByLoggedInPersonnel().subscribe((data) => {
                resolve(data);

            });
        });
    }

    async getPersonnelList() {
        let personnelQueryModel = new PerPersonnelQueryModel();
        personnelQueryModel.onlySubEmployee = true;
        personnelQueryModel.maxLevel = 1;
        personnelQueryModel.employeeTypeUuidList = this.employeeTypeUuidList || personnelQueryModel.employeeTypeUuidList;

        return new Promise((resolve) => {
            this.perPersonnelService.queryList(personnelQueryModel).subscribe((data) => {
                if (data.length > 0) {
                    this.modelList = data;
                    this.selectedPersonnelPickerData = this.modelList;
                    resolve(this.modelList);
                }
            });
        });
    }

    rowSelect() {
        this.onRowSelect.emit(this.selectedItem);
    }

    setPerData(event: PerPersonnelModel[], clearList = false) {
        if (event?.length > 0) {
            const existIdArr: Array<number> = this.modelList.map((it) => it.id);
            if (clearList === true) {
                //KOVAN-68057-11
                this.modelList = this.moveNewObjectsToFront(this.modelList, event);
                //KOVAN-68057-11
            } else {
                this.modelList.push(...event.filter((it) => !existIdArr.includes(it.id)));
            }
            this.setFirstItemSelected();
        } else {
            this.clearSelectedProps();
            this.modelList = [];
        }
        this.refreshPerPickerDisplayByModels();
        if (this.pickerSearchResult) {
            this.selectIfExist(this.pickerSearchResult.id);
        }
    }

    onSearchPersonnelSelected(e: PerPersonnelModel[]) {
        if (e.length > 0 && e[0].id) {
            this.selectIfExist(e[0].id);
        }
    }

    selectIfExist(id: number) {
        let itemIndex = this.modelList.findIndex((item) => item.id == id);
        if (itemIndex != -1) {
            this.modelList.splice(0, 0, this.modelList.splice(itemIndex, 1)[0]);
            this.setFirstItemSelected();
        }
    }

    moveNewObjectsToFront(originalArray, modifiedArray) {
        const newObjects = modifiedArray.filter((obj) => !originalArray.find((o) => o.id === obj.id));
        return [...newObjects, ...originalArray];
    }

    clearSelectedProps() {
        this.selectedItem = null;
        this.onListClear.emit();
    }

    rowDelete(model: PerPersonnelModel) {
        if (model) {
            this.onRowDelete.emit(model);
            let index = this.modelList.findIndex((it) => it.id === model.id);
            this.modelList.splice(index, 1);
            this.refreshPerPickerDisplayByModels();
        }
    }

    refreshPerPickerDisplayByModels() {
        this.selectedPersonnelPickerData = [];
        if (this.modelList.length > 0) {
            this.selectedPersonnelPickerData = this.modelList;

        }
        localStorage.setItem('selected_personnel', JSON.stringify(this.modelList));
    }

    getPictureFetchUrlByCmId(peopleId: number): string {
        return this.perPersonnelService.getPictureUrl(peopleId);
    }

    getPerSummary(model: PerPersonnelModel): string {
        return model.personSummaryText + ' ' + (model.registryNumber ? ' (' + model.registryNumber + ')' : '');
    }

    getPerDetail(model: PerPersonnelModel): string {
        return (
            (model.perPersonnelPosition ? model.perPersonnelPosition : '-') +
            ' / ' +
            (model.perPersonnelOrganization ? model.perPersonnelOrganization : '-')
        );
    }

    ngOnDestroy(): void {
        localStorage.setItem('selected_personnel_' + this.username, JSON.stringify(this.modelList));
    }

    getStorage(): Array<PerPersonnelModel> {
        let getItem = localStorage.getItem('selected_personnel_' + this.username);
        let getItemArr: Array<PerPersonnelModel> = JSON.parse(getItem);
        const converter = new JsonConvert();
        let convertedData = converter.deserializeArray(getItemArr, PerPersonnelModel);
        return convertedData;
    }

    clearList() {
        this.modelList = [];
        this.selectedPersonnelPickerData = [];
        localStorage.setItem('selected_personnel', JSON.stringify(this.modelList));
        this.selectedItem = null;
        this.onListClear.emit();
    }

    setFirstItemSelected() {
        if (this.modelList.length > 0) {
            this.selectedItem = this.modelList[0];

            this.onRowSelect.emit(this.selectedItem);
            setTimeout(() => {
                this.selectedItemIdObservable.next(this.selectedItem?.id);
            }, 100);
        }
    }
}
